// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};

(function() {
    BoostPFS.inject(this);

    // Customize style of Suggestion box
    SearchInput.prototype.customizeInstantSearch = function() {
        var suggestionElement = this.$uiMenuElement;
        var searchElement = this.$element;
        var searchBoxId = this.id;
    };

    // Bind Event for input search Mobile
    var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;

    InstantSearchMobile.prototype.afterShowSearchBoxMobile = function() {
        $('html').toggleClass('no-scroll-mobile-search');
    }
    InstantSearchMobile.prototype.afterOpenSuggestionMobile = function() {
        $('html').toggleClass('no-scroll-mobile-search');

        setTimeout(function() {
            if ($('.boost-pfs-search-suggestion-group ul li').length > 0 && !$('.boost-pfs-search-suggestion-group ul li').is(':visible')) {
                $('#boost-pfs-search-box-mobile').trigger('click');
                $('html').toggleClass('no-scroll-mobile-search');
            }
        }, 100);

    }
    InstantSearchMobile.prototype.afterCloseInstantSearchMobile = function(isClose) {
        if (isClose === true) $('html').removeClass('no-scroll-mobile-search');
    }

    InstantSearchMobile.prototype.bindEvents = function() {
        bindEventsMobile.call(this);

        var self = this;
        var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
        var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
        var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
        jQ(searchButtonMobile).off('click').click(function(e) {
            e.preventDefault();
            //e.stopPropagation();
            jQ(searchInputMobile).focus();
            self.openSuggestionMobile();
            jQ(searchCloseButtonMobile).trigger('click');

        });
    }

    // Bind Event for input search style 3
    var bindEvents = InstantSearchStyle3.prototype.bindEvents;
    InstantSearchStyle3.prototype.bindEvents = function() {
        bindEvents.call(this);

        var self = this;
        var searchButtonDesktop = '.site-header__links .search-button';
        var searchInputDesktop = '#SearchContainer #search-input';
        var searchCloseButtonDesktop = '.drawer__close > button';
        jQ(searchButtonDesktop).off('click').click(function(e) {
            e.preventDefault();
            //e.stopPropagation();
            jQ(searchInputDesktop).focus();
            self.openSuggestionStyle3();
            jQ(searchCloseButtonDesktop).trigger('click');

        });
    }

    // Fix search for the Flow theme
    jQ('.site-header__links .search-button').on('click', function() {
        setTimeout(function() {
            boostPFS.initSearchBox();
            if (Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
        }, 500);
    });

    InstantSearchApi.beforeCall = function(eventType, eventInfo) {
        if (Shopify && Globals) {
            Globals.instantSearchQueryParams.currency = Shopify.currency.active;
            Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate;
            Globals.instantSearchQueryParams.country = Shopify.country;
            Globals.instantSearchQueryParams.return_all_currency_fields = false;
        }
    }
})();